import { Base } from "./base.model";

export class ConsultaList<T> extends Base {  

    list: Array<T>;
	param1: string;
	param2: string;
	param3: string;
	param4: number;
	param5: number;
	param6: number;
	param7: string;
	param8: string;
	fecha_ini: Date;
	fecha_fin: Date;
	bean: T;
	bean2: T;
	beanAlterno: any;

	regInicial:number;
	regFinal:number;
	regXPagina:number;
	totalPaginas:number;
	pagina:number;
	sort: string;
	permisoProyectos: boolean;

}
